<template>
	<div class="content-class">
		<v-tabs color="black" dark slider-color="primary">
			<v-tab ripple>Utilisateurs</v-tab>
		</v-tabs>
		<user-list ref="userList" url="users" :global="true" :list-actions="listActions"> </user-list>
	</div>
</template>

<script>
import UserList from '../../components/users/user.list'
import { ERROR } from '../../variables'

export default {
	components: { UserList },
	data() {
		return {
			listActions: [
				{
					name: 'Exporter',
					function: async (filterString) => {
						try {
							const pagination = this.$refs.userList.pagination

							let url = `/users/export${filterString}`
							// TODO removed export limit !
							// url += (url.includes('?') ? '&' : '?') + 'limit=' + pagination.rowsPerPage + '&page=' + pagination.page
							if (pagination.sortBy) {
								let sortItem = this.$refs.userList.items.find((el) => el.header === pagination.sortBy)
								if (sortItem) {
									let sortFilter = sortItem.sort ? sortItem.sort : sortItem.header
									url += (url.includes('?') ? '&' : '?') + 'sort=' + (pagination.descending ? '-' : '') + sortFilter
								}
							}

							const { data } = await this.axios.get(url)
							let csvContent = 'data:text/csv;charset=utf-8,' + data
							let encodedUri = encodeURI(csvContent)

							const link = document.createElement('a')
							link.setAttribute('href', encodedUri)
							link.setAttribute('download', 'export.csv')
							link.click()

							link.click()
						} catch (err) {
							this.$store.dispatch(ERROR, err)
						}
					},
				},
			],
		}
	},
}
</script>

<style lang="scss">
.content-class {
	width: 100%;
	height: 100vh;
}
</style>



// WEBPACK FOOTER //
// src/pages/users/botUser.list.vue